import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LoadingCard } from "@/components/LoadingCard";
import { ClipperRunGame } from "@/components/loading-game/ClipperRunGame";

interface ProcessingStatusProps {
  status?: string | null;
  statusLabel: string;
  etaLabel?: string;
  description: string;
  backLabel: string;
  onBack: () => void;
}

export const ProcessingStatus = ({
  status,
  statusLabel,
  etaLabel,
  description,
  backLabel,
  onBack,
}: ProcessingStatusProps) => {
  return (
    <div className="flex w-full max-w-xl flex-col items-center gap-5 px-4">
      <LoadingCard
        message={statusLabel}
        etaLabel={etaLabel}
        description={description}
        status={status}
      >
        <div className="flex justify-center">
          <Button type="button" size="sm" variant="outline" onClick={onBack}>
            <ArrowLeft aria-hidden="true" />
            {backLabel}
          </Button>
        </div>
      </LoadingCard>
      <ClipperRunGame />
    </div>
  );
};
